// extracted by mini-css-extract-plugin
export default {"range-picker":"DateSelect_range-picker__0dKIt"};